/** Общие параметры регистрации и входа: открытый ключ, подписанный вызов, рабочее место нового устройства и PIN входа для входа по фразе */
export class SignedParams {
  publicKey: string
  challenge: string
  signature: string
  workspace?: string
  pin?: string

  constructor({ publicKey, challenge, signature, workspace, pin }: { publicKey: string, challenge: string, signature: string, workspace?: string, pin?: string }) {
    this.publicKey = publicKey
    this.challenge = challenge
    this.signature = signature
    this.workspace = workspace
    this.pin = pin
  }
}
